export default "__VITE_ASSET__15b747b7__"